import { useCallback } from 'react';
import { useRxData } from 'rxdb-hooks';

import { RxdbCollectionName } from '../rxdbCollectionName';
import type {
  EnvironmentalCondition,
  EnvironmentalConditionCollection,
} from './environmentalCondition.types';

const useEnvironmentalCondition = () => {
  const getEnvironmentalConditionQuery = useCallback(
    (collection: EnvironmentalConditionCollection) => collection?.find(),
    [],
  );

  const { result: environmentalConditionListData } = useRxData<EnvironmentalCondition>(
    RxdbCollectionName.ENVIRONMENTAL_CONDITION,
    getEnvironmentalConditionQuery,
    { json: true },
  );

  return { environmentalConditionListData };
};

export default useEnvironmentalCondition;
